export default __webpack_public_path__ + "static/media/moscow.34eefa67.png";